import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { GameLadyMeowSoundEvents } from "../event/GameSountEvent";
import { FeatureRedFishEvents } from "../../view/abstract/display/features/redfish/FeatureRedFish";
import { MainTransitionEvents } from "../../view/abstract/display/GameMainTransition";
export class GameSoundLadyMeowController extends SoundController {
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(FeatureRedFishEvents.FEATURE_START, this.playMusic);
        this.registerGame(GameLadyMeowSoundEvents.BOX_REVEAL, this.handleBoxReveal);
        this.registerGame(GameLadyMeowSoundEvents.BOX_SELECTED, this.handleBoxSelected);
        this.registerGame(GameLadyMeowSoundEvents.BOX1_IN, this.handleBox1In);
        this.registerGame(GameLadyMeowSoundEvents.BOX2_IN, this.handleBox2In);
        this.registerGame(GameLadyMeowSoundEvents.BOX3_IN, this.handleBox3In);
        this.registerGame(GameLadyMeowSoundEvents.BOX_OUT, this.handleBoxOut);
        this.registerGame(GameLadyMeowSoundEvents.SIAMESE_PADDLE_DING, this.handleSiamesePaddleDing);
        this.registerGame(GameLadyMeowSoundEvents.PADDLE_DING, this.handlePaddleDing);
        this.registerGame(GameLadyMeowSoundEvents.RAISE_PADDLE, this.handleRaisePaddle);
        this.registerGame(GameLadyMeowSoundEvents.LOWER_PADDLE, this.handleLowerPaddle);
        this.registerGame(GameLadyMeowSoundEvents.GAVEL, this.handleGavel);
        this.registerGame(GameLadyMeowSoundEvents.BID, this.handleBid);
        this.registerGame(MainTransitionEvents.BLACKOUT_MID_POINT, this.stopMusic);
    }
    playMusic() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_MUSIC"));
    }
    stopMusic() {
        this.stopSound(this.getSoundPropertiesFromId("MEOWLADY_MUSIC"));
    }
    handleBoxReveal() {
        this.playSound(this.getSoundPropertiesFromId("BOX_REVEAL"));
    }
    handleBoxSelected() {
        this.playSound(this.getSoundPropertiesFromId("BOX_SELECTED"));
    }
    handleBox1In() {
        this.playSound(this.getSoundPropertiesFromId("BOX1_IN"));
    }
    handleBox2In() {
        this.playSound(this.getSoundPropertiesFromId("BOX2_IN"));
    }
    handleBox3In() {
        this.playSound(this.getSoundPropertiesFromId("BOX3_IN"));
    }
    handleBoxOut() {
        this.playSound(this.getSoundPropertiesFromId("BOX_OUT"));
    }
    handleSiamesePaddleDing() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_SIAMESE_PADDLE_DING"));
    }
    handlePaddleDing() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_PADDLE_DING"));
    }
    handleRaisePaddle() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_RAISE_PADDLE"));
    }
    handleLowerPaddle() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_LOWER_PADDLE"));
    }
    handleGavel() {
        this.playSound(this.getSoundPropertiesFromId("MEOWLADY_GAVEL"));
    }
    handleBid() {
        const soundProperties = [
            this.getSoundPropertiesFromId("MEOwLADY_BID_1"),
            this.getSoundPropertiesFromId("MEOwLADY_BID_2"),
            this.getSoundPropertiesFromId("MEOwLADY_BID_3"),
            this.getSoundPropertiesFromId("MEOwLADY_BID_4"),
            this.getSoundPropertiesFromId("MEOwLADY_BID_5"),
        ][Math.floor(Math.random() * 5)];
        this.playSound(soundProperties);
    }
}
//# sourceMappingURL=GameSoundLadyMeowController.js.map